import {
    Datagrid,
    DateField,
    DateInput,
    EditButton,
    List,
    ListButton,
    ShowButton,
    TextField,
    TextInput,
    useGetRecordId,
    useTranslate
} from "react-admin";

import { rowStyles } from "../../utils/rowStyles";
import { ListPagination } from "../../utils/components/ListPagination";

import { ContentStatusField } from "../../utils/components/ContentStatusField";
import { PublicationStatusField } from "../../utils/components/PublicationStatusField";
import { SerieListActions } from "./components/SerieListActions";
import { PublicationStatusFilter } from "../../utils/components/form/PublicationStatusFilter";
import { ContentStatusFilter } from "../../utils/components/form/ContentStatusFilter";

function EpisodeListButton() {
    const recordId = useGetRecordId();
    const searchParams = new URLSearchParams({ filter: JSON.stringify({ serieUuid: recordId }) });

    return (
        <ListButton
            resource="product"
            label="resources.serie.episodeList"
            to={{
                pathname: "/product",
                search: searchParams.toString()
            }}
        />
    );
}

function SeasonListButton() {
    const recordId = useGetRecordId();
    const searchParams = new URLSearchParams({ filter: JSON.stringify({ serieUuid: recordId }) });

    return (
        <ListButton
            resource="season"
            label="resources.serie.seasonList"
            to={{
                pathname: "/season",
                search: searchParams.toString()
            }}
        />
    );
}

export function SerieList(): JSX.Element {
    const t = useTranslate();

    const filters = [
        <TextInput key="searchTerms-filter" label={t("resources.serie.fields.name")} source="searchTerms" alwaysOn />,
        <DateInput
            key="publication-from"
            source="rangePublicationDateBegin"
            label={t("resources.product.filters.rangePublicationDateBegin")}
        />,
        <DateInput key="publication-to" source="rangePublicationDateEnd" label={t("resources.product.filters.rangePublicationDateEnd")} />,

        <ContentStatusFilter source="status" label={t("resources.common.filters.status")} />,
        <PublicationStatusFilter source="publicationStatus" label={t("resources.common.filters.publicationStatus")} />,

        <TextInput key="searchTerms-id" label={t("resources.common.fields.id")} source="id" />
    ];

    return (
        <>
            <List
                hasCreate
                pagination={<ListPagination />}
                perPage={20}
                sort={{ field: "createdAt", order: "DESC" }}
                filters={filters}
                actions={<SerieListActions />}
            >
                <Datagrid rowStyle={rowStyles}>
                    <TextField source="name" sortBy="title" />
                    <TextField source="description" />
                    <ContentStatusField source="status" label={t("resources.common.fields.status")} />
                    <PublicationStatusField source="publicationStatus" label={t("resources.common.fields.publicationStatus")} />
                    <DateField label={t("resources.season.fields.publicationStartedAt")} source="publicationStartedAt" />
                    <DateField label={t("resources.season.fields.publicationEndedAt")} source="publicationEndedAt" />
                    <SeasonListButton />
                    <EpisodeListButton />
                    <EditButton />
                    <ShowButton />
                </Datagrid>
            </List>
        </>
    );
}
